// Bundle theme module
import Helper from './Classes/Helper';
import NSTheme from './NSTheme';
import Accordion from './Classes/Accordion';
import FocusHandler from './Classes/FocusHandler';
import LazyLoad from './Classes/Lazyload';
import ResponsiveTable from "./Classes/ResponsiveTable";
import FixedBackgroundSection from './Classes/FixedBackgroundSection';
import Link from './Classes/Link';
import Gallery from './Classes/Gallery';
import Tabs from './Classes/Tabs';
import Header from './Classes/Header';
import MainNavigation from './Classes/MainNavigation';
import ScrollSpy from './Classes/ScrollSpy';
import FrontPageAni from './Classes/FrontPageAni';
import Popup from './Classes/Popup';
import Glossary from './Classes/Glossary';
import BusinessModel from './Classes/BusinessModel';
import Search from './Classes/Search';
import Sticky from '../../node_modules/sticky-js';
import interactiveMap from './Classes/interactiveMap';
import placeOrderImage from './Classes/placeOrderImage';
import countUpNumbers from './Classes/countUpNumbers';
import Gri from './Classes/Gri';
import Jump from './Classes/Jump';
import StringReplacer from './Classes/StringReplacer';
import HeroVideo from "./Classes/HeroVideo";
import Video from "./Classes/Video";
import SymbolCircle from './Classes/SymbolCircle';
import MergeSuperscriptSpans from './Classes/MergeSuperscriptSpans';


(function () {
  document.addEventListener('DOMContentLoaded', () => {
    new StringReplacer({
      stringToBeReplaced: '<<check-icon>>',
      stringToReplace: `<span class="ns-audited__icon">
      <span class="audited-icon">
        <svg width="24px" height="19px" viewBox="0 0 24 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="check-icon">
          <g id="08_Infografiksite" transform="translate(-255.000000, -890.000000)" stroke="#0061AD" stroke-width="3" fill-rule="evenodd" fill="none">
            <polyline id="Rectangle" transform="translate(267.000000, 895.500000) rotate(-315.000000) translate(-267.000000, -895.500000) " points="272 885 272 906 262 906"></polyline>
          </g>
        </svg>
      </span>
    </span>`,
      elementSelectorToSearchFor: 'span.ns-highlight',
    });

    new BusinessModel({
      idName: 'toggle',
      className: 'popup--'
    });

    //new HeroVideo();

    new Video();

    new Glossary();

    new Header();

    new FixedBackgroundSection({
      fixedBgSelector: '.ns-fixed-bg',
    });

    new Jump({
      graphicSelector: '.ns-graphic'
    });

    new Gallery();

    new Accordion({
      accordions: '.js-toggle-accordion'
    });

    new Accordion({
      accordions: '.map-overlays__title'
    });

    new Tabs({
      tabContainerSelector: '.ns-tab-container',
      tabSelector: '.ns-tab'
    });

    new FocusHandler();

    // new LazyLoad();

    new Link({
      linksSelector: 'a.js-open-in-new-tab'
    });

    new ResponsiveTable({
      tableSelector: '.ns-table-wrap table',
      tableWrapperSelector: '.ns-table-wrap',
      breakPointLg: 1200,
      breakPointMd: 768,
      breakPointSm: 480,
      colCountNoSplit: 1,
      colCountEarlyBreak: 7,
      noSplitArray: []
    });

    new FrontPageAni({
      keyfigures: '.ns-keyfigure',
      horizontalImageWrapper: '.scroll-image',
      horizontalImageItem: '.scroll-image__item',
      horizontalImage: '.scroll-image__items-wrapper',
      colorContainer: '.ns-color-container',
      headerText: '.ns-header__text',
      breakpoint: 'min-width: 1171px'
    });


    new Popup({
      buttons: '.scroll-image__button',
      closebtn: '.close-btn',
      backdrops: '.popup__backdrop'
    });

    new interactiveMap({
      map: '.map-wrapper',
      mapContainer: '.interactive-map',
      buttons: '.map__btn',
      overlays: '.map-overlays__overlay',
      closebtn: '.map-overlays__close-btn',
      backdrops: '.map-overlays__backdrop'
    });

    new placeOrderImage({
      image: '.ns-img',
      parents: '.map-overlays__overlay',
      container: '.map-overlays__inner-container',
      breakpoint: 'min-width: 1171px'
    });

    new countUpNumbers({
      numbers: '.numbers__number-ani',
      classIn: 'is-in-viewport',
      classOut: 'is-not-in-viewport',
      decimalEN: '.',
      decimalDE: ',',
      separatorEN: '',
      separatorDE: ''
    });

    new Gri();


    new SymbolCircle();

    new MergeSuperscriptSpans({
      scopeSelector: 'td p',
      superscriptClass: 'superscript',
      mergedClass: 'merged-text',
      forceSingleLine: true
    });
  })
})();
